import { Button, Flex } from '@applyboard/crystal-ui'
import { Ref } from 'react'
import { useGetTimelineItems } from '../../../hooks'

type FormSubmitButtonGroupProps = Readonly<{
  cardNumber: number
  disabled?: boolean
  fullWidth?: boolean
  isLoading?: boolean
  submitButtonLabel?: string
  onSubmitApplication?: () => void
  onPreviousTabButton?: () => void
  formId: string
  focusRef?: Ref<HTMLButtonElement> | null
}>

export function FormSubmitButtonGroup(props: FormSubmitButtonGroupProps) {
  const timelineItems = useGetTimelineItems(null)
  const lastTimeline = timelineItems.at(-1)?.cardNumber ?? 6

  if (props.disabled) {
    return (
      <>
        {props.cardNumber > 1 ? (
          <PreviousButton
            disabled={props.isLoading}
            onPreviousTabButton={props.onPreviousTabButton}
          />
        ) : null}
        {props.cardNumber < lastTimeline && (
          <Button
            intent="primary"
            type="submit"
            width={props.fullWidth ? 'fill' : undefined}
            loading={props.isLoading}
            form={props.formId}
          >
            Continue
          </Button>
        )}
      </>
    )
  }

  if (props.onSubmitApplication) {
    return (
      <>
        <Button
          type="submit"
          intent="primary"
          emphasis="transparent"
          loading={props.isLoading}
          width={props.fullWidth ? 'fill' : undefined}
          form={props.formId}
          mr={8}
        >
          Save
        </Button>
        <PreviousButton
          disabled={props.isLoading}
          onPreviousTabButton={props.onPreviousTabButton}
        />
        <Button
          ref={props.focusRef}
          intent="primary"
          disabled={props.isLoading}
          onClick={props.onSubmitApplication}
          width={props.fullWidth ? 'fill' : undefined}
        >
          {props.submitButtonLabel ?? 'Save & Submit'}
        </Button>
      </>
    )
  }

  return (
    <Flex gap={3} align="center" justify="end" height="fill" direction="row">
      {props.cardNumber > 1 ? (
        <PreviousButton
          disabled={props.isLoading}
          onPreviousTabButton={props.onPreviousTabButton}
        />
      ) : null}
      <Button type="submit" intent="primary" loading={props.isLoading} form={props.formId}>
        Save & Continue
      </Button>
    </Flex>
  )
}

type PreviousButtonProps = Readonly<{
  disabled?: boolean
  onPreviousTabButton?: FormSubmitButtonGroupProps['onPreviousTabButton']
}>

function PreviousButton(props: PreviousButtonProps) {
  return (
    <Button
      disabled={props.disabled}
      type="button"
      intent="primary"
      emphasis="outlined"
      onClick={props.onPreviousTabButton}
    >
      Previous
    </Button>
  )
}
